import React from 'react'

import Iframe from './Iframe/Iframe'
import WebviewModal from './WebviewModal/WebviewModal'

import { API_URL } from '../../../config/config'

import { DYNAMIC } from '../../../constants/string'
import PatientReviewModal from '../../PatientReviewModal/PatientReviewModal'

export const Webview = props => {
  const isNateraWebviewSRC = props.iframeSettings.iframeSrc.includes(
    `${API_URL}/webview`,
  )
  const isDynamicNateraModal =
    isNateraWebviewSRC && props.settings.webviewType === DYNAMIC.toUpperCase()

  const isNateraPatientReview = props.iframeSettings.iframeSrc.includes(`${API_URL}/patient_review`, )

  return (
    <>
      {!isDynamicNateraModal && !isNateraPatientReview && (
        <Iframe
          chatId={props.chatId}
          device={props.device}
          isPanoramaPost={props.isPanoramaPost}
          color={props.settings.color}
          isMobile={props.isMobile}
          settings={props.settings}
          isUserIdle={props.isUserIdle}
          chatHistoryLevel={props.settings.chatHistoryLevel}
          iframeSettings={props.iframeSettings}
          setIframe={props.setIframe}
          setAnchorMenu={props.setAnchorMenu}
          setIsIframeContentLoaded={props.setIsIframeContentLoaded}
          setIsImageZoomed={props.setIsImageZoomed}
          setIsLoadingIframeData={props.setIsLoadingIframeData}
          isLoadingIframeData={props.isLoadingIframeData}
          widgetIframeSource={props.widgetIframeSource}
          setWidgetIframeSource={props.setWidgetIframeSource}
          language={props.language}
        />
      )}
      {isDynamicNateraModal && (
        <WebviewModal
          chatId={props.chatId}
          settings={props.settings}
          isMobile={props.isMobile}
          setIframe={props.setIframe}
          isUserIdle={props.isUserIdle}
          isPanoramaPost={props.isPanoramaPost}
          iframeSettings={props.iframeSettings}
          isOpen={props.iframeSettings.isIframeOpen}
          isMaximized={props.isMaximized}
        />
      )}
      {isNateraPatientReview && (
        <PatientReviewModal
          settings={props.settings}
          setIframe={props.setIframe}
          iframeSettings={props.iframeSettings}
          persistentMenuButtonRef={props.persistentMenuButtonRef}
        />
      )}
    </>
  )
}
